import { Box, Card, CardContent, Fab, Typography } from "@mui/material";
import React, { FC } from "react";
import AddIcon from "@mui/icons-material/Add";

interface AddItemCardProps {
  title?: string;
  href?: string;
  onClick?: () => void;
}

export const AddItemCard: FC<AddItemCardProps> = ({
  title = "Add a document",
  href,
  onClick,
}): JSX.Element => {
  const componentType = href ? "a" : "button";

  return (
    <Card
      sx={{
        my: 2,
        mr: 1,
        width: {
          sm: 197,
          xs: "100%",
        },
        transition: "box-shadow 0.1s ease-in-out",
        ":hover": {
          boxShadow: 10, // theme.shadows[20]
        },
        minHeight: 275,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (onClick) onClick();
      }}
    >
      <CardContent
        sx={{
          p: 0,
          "&:last-child": {
            pb: 0,
          },
        }}
      >
        <Box
          component={componentType as React.ElementType}
          aria-label={title}
          sx={{
            textDecoration: "none !important",
            backgroundColor: "transparent",
            border: "none",
          }}
        >
          <Box
            sx={{
              maxWidth: 72,
              mx: "auto",
              marginBottom: "1rem",
            }}
          >
            <Fab
              color="primary"
              aria-label="add"
              sx={{ boxShadow: "none", WebkitBoxShadow: "0" }}
              size="medium"
            >
              <AddIcon />
            </Fab>
          </Box>
          <Typography
            className="addItemTitle"
            color={"primary.main"}
            sx={{ fontWeight: "bold" }}
          >
            {title}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
